import { IconProps } from '../types';

export const DownIcon = (props: IconProps): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={14} height={8} fill="none" {...props}>
      <path fill="#192839" d="m7 5.172 4.95-4.95 1.414 1.415L7 8 .636 1.637 2.05.223 7 5.173Z" />
    </svg>
  );
};
